export const getInterview = (state) =>
  state.images.filter(({ category }) => category.includes("interview"));
export const getCreations = (state) =>
  state.images.filter(({ category }) => category.includes("creations"));
export const getIntro = (state) =>
  state.images.find(({ category }) => category.includes("intro"));
export const getContacts = (state) =>
  state.images.filter(({ category }) => category.includes("contacts"));
